export default function init(container: HTMLElement) {
    // Buscador
    const searchOpen: HTMLElement | null = container.querySelector('.js-search-open');
    const searchForm: HTMLFormElement | null = container.querySelector('.js-search-form');
    const searchInput: HTMLElement | null = container.querySelector('.js-serach-input');

    // Menu
    const openMenu: HTMLElement | null = container.querySelector('.js-menu-open');
    const closeMenu: HTMLElement | null = container.querySelector('.js-menu-close');
    const lateralMenu: HTMLElement | null = container.querySelector('.js-lateral-menu');
    const lateralMenuBox: HTMLElement | null = container.querySelector('.js-lateral-menu-box');
    const openSubmenu: NodeListOf<HTMLElement> | null = container.querySelectorAll('.js-submenu > a');
    const allSubmenu: NodeListOf<HTMLElement> | null = container.querySelectorAll('.sub-menu');

    // dropdown logged
    const openLogged: HTMLElement | null = container.querySelector('.js-open-logged');
    const logged: HTMLElement | null = container.querySelector('.js-logged');

    function toggleSearch() {
        if (searchForm && searchOpen && searchInput) {
            searchForm.classList.toggle('opened');
            searchOpen.classList.toggle('active', searchOpen.classList.contains('opened'));
            searchInput.focus();
        }
    }

    function toggleSubmenu(button: HTMLElement) {
        const submenu: HTMLElement | null = button.parentElement!.querySelector('.sub-menu');
        if (submenu && allSubmenu) {
            allSubmenu.forEach((menu) => {
                if (menu !== submenu) {
                    menu.classList.remove('opened');
                    menu.parentElement!.querySelector('a')!.classList.remove('active');
                }
            });
            const isOpened = submenu.classList.toggle('opened');
            button.classList.toggle('active', isOpened);
        }
    }

    function handleDocumentClick(e: MouseEvent) {
        // click afuera de logged, del buscador o del lateral menú los cierra
        const target = e.target as HTMLElement;
        if (
            searchForm &&
            searchOpen &&
            !searchForm.contains(target) &&
            !searchOpen.contains(target) &&
            searchForm.classList.contains('opened')
        ) {
            searchForm.classList.remove('opened');
            searchOpen.classList.remove('active');
        }

        if (
            logged &&
            openLogged &&
            !logged.contains(target) &&
            !openLogged.contains(target) &&
            logged.classList.contains('active')
        ) {
            logged.classList.remove('active');
            openLogged.classList.remove('active');
        }

        if (!container.contains(target) && allSubmenu) {
            allSubmenu.forEach((menu) => menu.classList.remove('opened'));
        }
    }

    function toggleLogged() {
        if (logged && openLogged) {
            const isActive = logged.classList.toggle('active');
            openLogged.classList.toggle('active', isActive);
        }
    }

    function addSafariClass() {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            document.body.classList.add('is-safari');
        }
    }

    if (searchOpen) {
        searchOpen.addEventListener('click', (e) => {
            e.preventDefault();
            toggleSearch();
        });
    }

    if (openMenu && lateralMenu) {
        openMenu.addEventListener('click', (e) => {
            e.preventDefault();
            lateralMenu.classList.add('opened');
            document.body.dataset.menu = 'opened';
        });
    }

    if (closeMenu && lateralMenu) {
        closeMenu.addEventListener('click', (e) => {
            e.preventDefault();
            lateralMenu.classList.remove('opened');
            document.body.dataset.menu = 'closed';
        });
    }

    if (openSubmenu) {
        openSubmenu.forEach((bttn) => {
            bttn.addEventListener('click', (e) => {
                e.preventDefault();
                const submenu = bttn.parentElement!.querySelector('.sub-menu');
                if (submenu) {
                    const submenuHeight = submenu.scrollHeight;
                    bttn.parentElement!.style.setProperty('--height', `${submenuHeight}px`);
                }
                toggleSubmenu(bttn);
            });
        });
    }

    if (lateralMenu) {
        lateralMenu.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            if (lateralMenuBox && document.body.dataset.menu === 'opened' && !lateralMenuBox.contains(target)) {
                lateralMenu.classList.remove('opened');
                document.body.dataset.menu = 'closed';
            }
        });
    }

    if (openLogged && document.body.classList.contains('logged-in')) {
        openLogged.addEventListener('click', (e) => {
            e.preventDefault();
            toggleLogged();
        });
    }
    document.addEventListener('click', (e) => {
        handleDocumentClick(e);
    });

    addSafariClass();
}
